export const DEFAULT_SMOOTH_INTERPOLATE = "monotone";

export const DEFAULT_LINEAR_INTERPOLATE = "linear";
//# sourceMappingURL=interpolate.js.map
